import { gql } from "lib/apolloClient";

export const getOgranizationDataQuery = gql`
  query getOgranizationData(
    $organizationId: ID!
    $type: String!
    $curriculumProgramId: ID
    $academicYearId: ID
    $filters: bulkDataDownloadFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        name
        organizationDataBulkDownload(
          type: $type
          curriculumProgramId: $curriculumProgramId
          academicYearId: $academicYearId
          filters: $filters
        )
      }
    }
  }
`;

export const getOrganizationBasicCoursesQuery = gql`
  query getOrganizationCoursesQuery(
    $organizationId: ID!
    $filters: CourseFilterInput
    $first: Int
    $after: String
    $orderBy: ORDER_BY_ENUM = TITLE
    $orderByDirection: ORDER_BY_DIRECTION = ASC
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(
          first: $first
          after: $after
          orderBy: $orderBy
          orderByDirection: $orderByDirection
          filters: $filters
        ) {
          edges {
            node {
              id
              title
              isArchived
              profileImageData {
                url
                icon
              }
              curriculumProgram {
                id
                type
                acronym
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;

export const getBulkUploadTemplateURLQuery = gql`
  query getBulkUploadTemplateURL(
    $organizationId: ID!
    $type: String!
    $curriculumProgramId: ID
    $academicYearId: ID
    $filters: bulkDataDownloadFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        name
        organizationDataBulkDownload(
          type: $type
          curriculumProgramId: $curriculumProgramId
          filters: $filters
          academicYearId: $academicYearId
        )
      }
    }
  }
`;

export const getCourseCount = gql`
  query getCourseCount($organizationId: ID!, $filters: CourseFilterInput) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(filters: $filters) {
          totalCount
        }
      }
    }
  }
`;

export const getStaffCount = gql`
  query getStaffCount(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        staff(filters: $filters) {
          userCount {
            role
            totalCount
            __typename
          }
        }
      }
    }
  }
`;

export const getStudentCount = gql`
  query getStudentCount(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        students(filters: $filters) {
          totalCount
        }
      }
    }
  }
`;

export const getRnPLevelsFeedQuery = gql`
  query getRnPLevelsFeed($id: ID!, $rnpViewFilters: RnpViewFilters!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        rnpView(filters: $rnpViewFilters) {
          id
          ... on RnPRole {
            id
            label
            description
            globalLevel
            globalRole {
              id
            }
            assignedUserCount
            isDefaultRole
            isCustomRole
            isSuperAdmin
          }
        }
      }
    }
  }
`;
